<nz-modal
  [nzVisible]="true"
  [nzTitle]="title"
  [nzWidth]="width"
  (nzOnOk)="onConfirm()"
  (nzOnCancel)="onCancel()"
  [nzOkText]="okText"
  [nzCancelText]="cancelText"
  [nzOkType]="okType"
>
  <ng-container *nzModalContent>
    <p>{{ content }}</p></ng-container
  >
</nz-modal>
